<template>
  <component
    :ref="partnerDetailsTabMetaData.myRefName"
    :is="partnerDetailsTabMetaData.componentName"
    v-bind="partnerDetailsTabMetaData.props"
  ></component>
</template>

<script lang="ts">
import FTab from "@/components/generic/FTab.vue";
import { Vue, Component } from "vue-property-decorator";
import PartnerDetailsFTabMDP from "./PartnerDetailsFTabMDP";
import TaskFTabMDP from "./TaskFTabMDP";

@Component({
  components: {
    FTab,
  },
})
export default class PartnerDetailsFTab extends Vue {
  get partnerDetailsTabMetaData(): any {
    return new PartnerDetailsFTabMDP({ taskRoot: this }).getMetaData();
  }
}
</script>

<style scoped></style>
